<template>
  <div>
    <div
      v-if="viewMode === 'card' || viewMode === 'compact-card'"
    >
      <div
        class="ticket-card"
        :class="(viewMode === 'compact-card') ? '--compact' : ''"
        :style="{ 'color': color, 'border-color': color, 'background-color': calcBackgroundColor(color), 'margin-right': getCardMargin(), 'z-index': getZIndex(), 'cursor': canSelect ? 'pointer' : 'default'}"
        @click.self="cardClick(id, status)"
      >
        <div
          v-if="canSelect"
          type="button"
          class="select"
          :class="{selected: selectedId === id}"
        >
          <b-form-checkbox
            v-model="selectedId"
            :value="id"
            :disabled="['returned', 'revoked'].includes(status)"
            inline
          />
        </div>
        <button
          v-if="['created', 'payed'].some(el => status.includes(el))"
          type="button"
          aria-label="Close"
          class="close"
          @click="$emit('remove', id)"
        >
          ×
        </button>
        <feather-icon
          v-if="viewMode !== 'compact-card'"
          icon="CheckCircleIcon"
          size="28"
        />
        <div
          v-if="viewMode === 'compact-card'"
          class="compact-card-top"
          :style="{ 'border-color': color }"
        />
        <div
          @click="cardClickChild(id)"
        >
          <div class="row-seat">
            {{ row }} ряд {{ seat }} место
          </div>
          <div class="label">
            {{ label }}
          </div>
          <div
            class="price"
            :style="{ 'border-color': color }"
          >
            <span v-if="newPrice === null">
              <s v-if="strikePrice && (status === 'revoked' || status === 'returned')">{{ price }} ₽</s>
              <span v-else>{{ price }}</span>
            </span>
            <span v-else>
              <s class="old_price">{{ price }} ₽</s>
              <p v-if="status === 'revoked' || status === 'returned'"><s>{{ newPrice }} ₽</s></p>
              <p v-else>{{ newPrice }} ₽</p>
            </span>
          </div>
        </div>
      </div>
      <div class="after-card">
        <div>
          <b-link
            :to="{ name: 'reference-tickets'}"
          >
            {{ ticketNumber }}
          </b-link>
        </div>
        <div
          v-if="status !== '—'"
        >
          <b-badge
            v-if="status.length > 0"
            :variant="getOrderStatusVariant(status)"
          >
            {{ getOrderStatusName(status) }}
          </b-badge>
        </div>
      </div>
    </div>
    <div
      v-if="viewMode === 'line'"
      class="my-1 d-flex align-items-center"
    >
      <b-form-checkbox
        v-if="canSelect"
        v-model="selectedId"
        :value="id"
        inline
      />
      <span class="mr-2">Зона: <b>{{ label }}</b></span>
      <span class="mr-2">Ряд: <b>{{ row }}</b></span>
      <span class="mr-2">Место: <b>{{ seat }}</b></span>
      <b-link
        class="text-danger"
        @click.prevent="$emit('remove', id)"
      >
        <feather-icon icon="XIcon" />
      </b-link>
    </div>
  </div>
</template>
<script>
import {
  BLink,
  BFormCheckbox,
  BBadge,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import helpers from '@/mixins/globalHelpers'

export default {
  components: {
    BLink,
    BFormCheckbox,
    BBadge,
  },
  emits: ['remove', 'select', 'unSelect'],
  mixins: [helpers],
  props: {
    id: {
      type: Number,
      required: true,
    },
    row: {
      type: Number,
      required: true,
    },
    seat: {
      type: Number | String,
      required: true,
    },
    label: {
      type: String,
      default: '-',
    },
    price: {
      type: Number,
      default: 0,
    },
    newPrice: {
      type: Number | null,
      default: null,
    },
    strikePrice: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '#7367f0',
    },
    viewMode: {
      type: String,
      default: 'card',
    },
    canSelect: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
    ticketNumber: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 1,
    },
    ticketsCount: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    cssProps() {
      return {

      }
    },
  },
  setup(props, { emit }) {
    const selectedId = ref(false)
    const shadeColor = (color, amount) => `#${color.replace(/^#/, '').replace(/../g, color => (`0${Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)}`).substr(-2))}`
    const calcBackgroundColor = color => shadeColor(color, 130)

    const cardClick = (id, status) => {
      // check if can select
      if (!['returned', 'revoked'].includes(status)) {
        if (selectedId.value === false) {
          selectedId.value = id
        } else {
          selectedId.value = false
        }
      }
    }

    const cardClickChild = (id, status) => {
      cardClick(id, status)
    }

    const getCardMargin = () => {
      let m = 10
      if (props.viewMode === 'compact-card') {
        m = -25 * (props.ticketsCount * 0.5)
      }
      return `${m}px`
    }

    const getZIndex = () => props.ticketsCount - props.index

    watch(selectedId, (newValue, oldValue) => {
      if (selectedId.value === false) {
        emit('unSelect', oldValue)
      } else {
        emit('select', selectedId.value)
      }
    })

    watch(() => props.isSelected, v => {
      selectedId.value = (v) ? props.id : false
    })

    return {
      calcBackgroundColor,
      cardClick,
      cardClickChild,
      selectedId,
      getCardMargin,
      getZIndex,
    }
  },
}
</script>
<style lang="scss" scoped>
  .ticket-card{
    width: 160px;
    height: 200px;
    padding: 20px 10px;
    text-align: center;
    border-radius: 6px;
    border: solid 1px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-right: 20px;
    position: relative;

    &.--compact{
      top: 0;
      transition: all .1s ease-in-out;
      height: 160px;
      padding: 0;
    }

    &.--compact:hover{
      z-index: 10 !important;
      top: -10px;
      box-shadow: 5px 5px 5px rgb(0 0 0 / 6%);
    }
  }
  .after-card{
    text-align: center;
    margin-right: 20px;
  }
  .after-card div{
    margin: 5px 0;
  }
  .row-seat{
    font-weight: 500;
    font-size: 15px;
    line-height: 50px;
    height: 50px;
  }
  .label{
    font-size: 12px;
    max-height: 64px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    padding: 0 5px;
  }
  .price{
    font-weight: 500;
    font-size: 15px;
  }
  .ticket-card.--compact .price{
    width: 100%;
    height: 50px;
    line-height: 50px;
  }
  .old_price{
    font-weight: 100;
    font-size: 13px;
  }
  .close{
    position: absolute;
    padding: 0.2rem 0.62rem;
    box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
    border-radius: 0.357rem;
    background: #fff;
    top: -5px;
    right: -5px;
    opacity: 1 !important;
    display: none;
  }
  .ticket-card:hover .close{
    display: block;
  }
  .select{
    position: absolute;
    padding: 0.5rem 0.62rem 0.2rem 0.62rem;
    box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
    border-radius: 0.357rem;
    background: #fff;
    top: -5px;
    left: -5px;
    display: none;
  }
  .select .custom-checkbox.custom-control{
    margin-right: 0;
    padding-left: 1.4rem;
    padding-top: 1.4rem;
  }
  .ticket-card:hover .select,
  .select.selected{
    display: block;
  }
  .compact-card-top{
    display: none;
  }
  .ticket-card.--compact .compact-card-top{
    width: 100%;
    height: 10px;
    /*border-bottom: dashed 1px black;*/
    display: none;
  }
</style>
